import React from "react";
import { useBrand } from "context/BrandContext";

interface PaperclipIconProps {
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const PaperclipIcon: React.FC<PaperclipIconProps> = ({
  className,
  style,
  onClick,
}) => {
  const { theme } = useBrand();
  const paperClipIcon = theme.aiChatPaperclipIcon;

  return (
    <div
      className="chat-icons-paperclip-container"
      onClick={onClick}
      style={{ cursor: onClick ? 'pointer' : 'default', ...style }}
    >
      <img
        src={`${process.env.PUBLIC_URL}${paperClipIcon}`}
        className={`chat-paperclip-icon ${className || ''}`}
        alt="Attach file"
      />
    </div>
  );
};
